export const ISRESULT = 'ISRESULT';
//Layout
export const GET_DATA_CONFIRM = 'GET_DATA_CONFIRM';
export const GET_DATA_CONFIRM_SUCCEEDED = 'GET_DATA_CONFIRM_SUCCEEDED';
export const REQUERT_CONFIRM_FAILED = 'REQUERT_CONFIRM_FAILED';
//PlanHandle
export const GET_DATA_PLANHANDLE_STEP = 'GET_DATA_PLANHANDLE_STEP';
export const GET_DATA_PLANHANDLE_STEP_SUCCEEDED = 'GET_DATA_PLANHANDLE_STEP_SUCCEEDED';
export const REQUERT_PLANHANDLE_STEP_FAILED = 'REQUERT_PLANHANDLE_STEP_FAILED';